module.exports = __webpack_public_path__ + "img/info03.842353ab.png";